import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type StreamingChartsFragment = {
	__typename?: 'HMStreamingCharts';
	category: string;
	moduleID: number;
	type: string;
	translatables: { __typename?: 'ModuleTranslatables'; badge: string; title: string };
	titles: Array<
		| {
				__typename?: 'Movie';
				id: string;
				content: { __typename?: 'MovieContent'; title: string; fullPath: string; posterUrl?: string | null };
				streamingCharts: {
					__typename?: 'StreamingChartsConnection';
					edges?: Array<{
						__typename?: 'StreamingChartsTitlesEdge';
						streamingChartInfo?: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
						} | null;
					}> | null;
				};
		  }
		| {
				__typename?: 'Season';
				id: string;
				content: { __typename?: 'SeasonContent'; title: string; fullPath: string; posterUrl?: string | null };
				streamingCharts: {
					__typename?: 'StreamingChartsConnection';
					edges?: Array<{
						__typename?: 'StreamingChartsTitlesEdge';
						streamingChartInfo?: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
						} | null;
					}> | null;
				};
		  }
		| {
				__typename?: 'Show';
				id: string;
				content: { __typename?: 'ShowContent'; title: string; fullPath: string; posterUrl?: string | null };
				streamingCharts: {
					__typename?: 'StreamingChartsConnection';
					edges?: Array<{
						__typename?: 'StreamingChartsTitlesEdge';
						streamingChartInfo?: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
						} | null;
					}> | null;
				};
		  }
	>;
};

export const StreamingChartsFragmentDoc = gql`
	fragment StreamingCharts on HMStreamingCharts {
		category
		moduleID
		translatables {
			badge
			title
		}
		type
		titles {
			id
			content(country: $country, language: $language) {
				title
				fullPath
				posterUrl
			}
			streamingCharts(filter: $streamingChartsFilter) {
				edges {
					streamingChartInfo {
						rank
						trend
						trendDifference
					}
				}
			}
		}
	}
`;
